/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'

// Create Virtual Routes

const ResourcesLazyImport = createFileRoute('/resources')()
const ContactLazyImport = createFileRoute('/contact')()
const AboutLazyImport = createFileRoute('/about')()
const IndexLazyImport = createFileRoute('/')()
const RidingsIndexLazyImport = createFileRoute('/ridings/')()
const RidingsElectionLazyImport = createFileRoute('/ridings/$election')()
const RidingsElectionRidingLazyImport = createFileRoute(
  '/ridings/$election/$riding',
)()

// Create/Update Routes

const ResourcesLazyRoute = ResourcesLazyImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/resources.lazy').then((d) => d.Route))

const ContactLazyRoute = ContactLazyImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/contact.lazy').then((d) => d.Route))

const AboutLazyRoute = AboutLazyImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const RidingsIndexLazyRoute = RidingsIndexLazyImport.update({
  id: '/ridings/',
  path: '/ridings/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/ridings/index.lazy').then((d) => d.Route))

const RidingsElectionLazyRoute = RidingsElectionLazyImport.update({
  id: '/ridings/$election',
  path: '/ridings/$election',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/ridings/$election.lazy').then((d) => d.Route),
)

const RidingsElectionRidingLazyRoute = RidingsElectionRidingLazyImport.update({
  id: '/$riding',
  path: '/$riding',
  getParentRoute: () => RidingsElectionLazyRoute,
} as any).lazy(() =>
  import('./routes/ridings/$election/$riding.lazy').then((d) => d.Route),
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactLazyImport
      parentRoute: typeof rootRoute
    }
    '/resources': {
      id: '/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof ResourcesLazyImport
      parentRoute: typeof rootRoute
    }
    '/ridings/$election': {
      id: '/ridings/$election'
      path: '/ridings/$election'
      fullPath: '/ridings/$election'
      preLoaderRoute: typeof RidingsElectionLazyImport
      parentRoute: typeof rootRoute
    }
    '/ridings/': {
      id: '/ridings/'
      path: '/ridings'
      fullPath: '/ridings'
      preLoaderRoute: typeof RidingsIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/ridings/$election/$riding': {
      id: '/ridings/$election/$riding'
      path: '/$riding'
      fullPath: '/ridings/$election/$riding'
      preLoaderRoute: typeof RidingsElectionRidingLazyImport
      parentRoute: typeof RidingsElectionLazyImport
    }
  }
}

// Create and export the route tree

interface RidingsElectionLazyRouteChildren {
  RidingsElectionRidingLazyRoute: typeof RidingsElectionRidingLazyRoute
}

const RidingsElectionLazyRouteChildren: RidingsElectionLazyRouteChildren = {
  RidingsElectionRidingLazyRoute: RidingsElectionRidingLazyRoute,
}

const RidingsElectionLazyRouteWithChildren =
  RidingsElectionLazyRoute._addFileChildren(RidingsElectionLazyRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/contact': typeof ContactLazyRoute
  '/resources': typeof ResourcesLazyRoute
  '/ridings/$election': typeof RidingsElectionLazyRouteWithChildren
  '/ridings': typeof RidingsIndexLazyRoute
  '/ridings/$election/$riding': typeof RidingsElectionRidingLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/contact': typeof ContactLazyRoute
  '/resources': typeof ResourcesLazyRoute
  '/ridings/$election': typeof RidingsElectionLazyRouteWithChildren
  '/ridings': typeof RidingsIndexLazyRoute
  '/ridings/$election/$riding': typeof RidingsElectionRidingLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/contact': typeof ContactLazyRoute
  '/resources': typeof ResourcesLazyRoute
  '/ridings/$election': typeof RidingsElectionLazyRouteWithChildren
  '/ridings/': typeof RidingsIndexLazyRoute
  '/ridings/$election/$riding': typeof RidingsElectionRidingLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/contact'
    | '/resources'
    | '/ridings/$election'
    | '/ridings'
    | '/ridings/$election/$riding'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact'
    | '/resources'
    | '/ridings/$election'
    | '/ridings'
    | '/ridings/$election/$riding'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/contact'
    | '/resources'
    | '/ridings/$election'
    | '/ridings/'
    | '/ridings/$election/$riding'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AboutLazyRoute: typeof AboutLazyRoute
  ContactLazyRoute: typeof ContactLazyRoute
  ResourcesLazyRoute: typeof ResourcesLazyRoute
  RidingsElectionLazyRoute: typeof RidingsElectionLazyRouteWithChildren
  RidingsIndexLazyRoute: typeof RidingsIndexLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AboutLazyRoute: AboutLazyRoute,
  ContactLazyRoute: ContactLazyRoute,
  ResourcesLazyRoute: ResourcesLazyRoute,
  RidingsElectionLazyRoute: RidingsElectionLazyRouteWithChildren,
  RidingsIndexLazyRoute: RidingsIndexLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/contact",
        "/resources",
        "/ridings/$election",
        "/ridings/"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/contact": {
      "filePath": "contact.lazy.tsx"
    },
    "/resources": {
      "filePath": "resources.lazy.tsx"
    },
    "/ridings/$election": {
      "filePath": "ridings/$election.lazy.tsx",
      "children": [
        "/ridings/$election/$riding"
      ]
    },
    "/ridings/": {
      "filePath": "ridings/index.lazy.tsx"
    },
    "/ridings/$election/$riding": {
      "filePath": "ridings/$election/$riding.lazy.tsx",
      "parent": "/ridings/$election"
    }
  }
}
ROUTE_MANIFEST_END */
